import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from "@angular/router";
import { FeatureFlagsStateService } from "@shared/services/feature-flags-state.service";
import type { CustomerFeature } from "@ophardt/shopware-api";

@Injectable({
  providedIn: "root",
})
export class FeatureFlagGuard implements CanActivate {
  private readonly featureFlagsStateService = inject(FeatureFlagsStateService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    const requiredFeature = route.data["featureFlag"] as CustomerFeature;

    if (!requiredFeature) {
      return true;
    }

    const isFeatureEnabled = this.featureFlagsStateService.isFeatureEnabled(requiredFeature);

    if (!isFeatureEnabled) {
      void this.router.navigate(["/account/overview"]);
      return false;
    }

    return true;
  }
}
